import React from 'react';
import ANavBar from 'antd-mobile/lib/nav-bar';



export default class NavBar extends ANavBar {}